<div class="custom-overlay-wrapper">
  @if (selectedView === VIEWS.DEFAULT) {
    <app-mention-overlay></app-mention-overlay>
  }
  @if (selectedView === VIEWS.STYLED_OPTIONS_LIST) {
    <app-options-list-view
      (selectedOption)="registerSelectedOption($event)"
      [listItems]="data?.listItems ?? []"
      [disabledList]="data?.disabledList ?? []"
    ></app-options-list-view>
  }
  @if (selectedView === VIEWS.CROPPER) {
    <app-img-preview [data]="data"></app-img-preview>
  }
</div>
